import {
  Calendar,
  CalendarFilter,
  Identifiable,
  Planzone,
  event as eventMock,
  milestone as milestoneMock,
  unavailability as unavailabilityMock,
  task as taskMock,
  calendarHolidays as calendarHolidaysMock,
  UnavailabilityReason,
} from "@planzone/dto";
import { HttpClient, HttpMethods } from "@planzone/services";

function getCalendar(httpClient: HttpClient) {
  return (planzone: Identifiable<Planzone>, filter: CalendarFilter) =>
    httpClient
      .sendHttpRequest<Calendar>({
        endpoint: `/planzones/calendar`,
        method: HttpMethods.POST,
        data: {
          startDate: filter.startDate,
          endDate: filter.endDate,
          ...(filter.zones?.length && {
            zoneUuids: filter.zones.map(({ uuid }) => uuid),
          }),
          ...(filter.projects?.length && {
            projectUuids: filter.projects.map(({ uuid }) => uuid),
          }),
          ...(filter.resources?.length && {
            resourceUuids: filter.resources.map(({ uuid }) => uuid),
          }),
          ...(filter.projectPortfolios?.length && {
            portfolioUuids: filter.projectPortfolios.map(({ uuid }) => uuid),
          }),
          ...(filter.projectStatuses?.length && {
            statusUuids: filter.projectStatuses.map(({ uuid }) => uuid),
          }),
          ...(filter.projectsTags?.length && {
            tags: filter.projectsTags.map(({ name }) => name),
          }),
          ...(filter.elementTypes?.length && {
            elementTypes: filter.elementTypes,
          }),
          ...(filter.scope && { scope: filter.scope }),
        },
      })
      .then((calendar) => ({
        ...calendar,
        events: calendar.events.map((event) => ({
          ...eventMock,
          ...event,
        })),
        milestones: calendar.milestones.map((milestone) => ({
          ...milestoneMock,
          ...milestone,
        })),
        tasks: calendar.tasks.map((task) => ({
          ...taskMock,
          ...task,
        })),
        unavailabilities: calendar.unavailabilities.map((unavailability) => ({
          ...unavailabilityMock,
          ...unavailability,
          reason:
            "unavailabilityReason" in unavailability
              ? (unavailability.unavailabilityReason as Identifiable<UnavailabilityReason>)
              : unavailability.reason,
        })),
        calendarsHolidays: (calendar.calendarsHolidays || []).map((cal) => ({
          ...calendarHolidaysMock,
          ...cal,
        })),
      }));
}

export { getCalendar };
